import Navbar        from './components/Navbar';
import Hero          from './components/Hero';
import StatsBar      from './components/StatsBar';
import WhyAiva       from './components/WhyAiva';
import BotCatalog    from './components/BotCatalog';
import HowItWorks    from './components/HowItWorks';
import DynamicReports from './components/DynamicReports';
import Platforms     from './components/Platforms';
import Testimonials  from './components/Testimonials';
import Pricing       from './components/Pricing';
import Contact       from './components/Contact';
import Footer        from './components/Footer';
import './styles/globals.css';
import { BrowserRouter as Router, Routes, Route, BrowserRouter } from 'react-router-dom';


export default function App() {
  return (
    <BrowserRouter basename="/microsite/">
      <Navbar />
      <Hero />
      <StatsBar />
      <WhyAiva />
      <BotCatalog />
      <HowItWorks />
      <DynamicReports />
      <Platforms />
      <Testimonials />
      <Pricing />
      <Contact />
      <Footer />
    </BrowserRouter>
  );
}
